<template>
  <!--  楼盘信息-->
  <div class="poor">
    <div class="poor_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="楼盘名字">
                <el-input
                  placeholder="请输入名称"
                  v-model="searchData.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼盘手机号">
                <el-input
                  placeholder="请输入手机号"
                  v-model="searchData.phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="类型">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.type"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button
              size="mini"
              style="width: 90px; margin-left: 120px"
              type="primary"
              @click="messageAdd"
              >添加</el-button
            >
            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="messageSearch"
              >查询</el-button
            >

            <el-button
              size="mini"
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card v-loading="loading">
        <el-table
          :data="list"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="floorName"
            label="楼盘名称"
            align="center"
            width="200"
            fixed
          ></el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.type == 1">最新开盘</span>
              <span v-if="row.type == 2">热门楼盘</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            align="center"
            width="300"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            width="120"
          ></el-table-column>

          <el-table-column
            prop="likeCount"
            label="点赞数"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="floorDesc"
            label="楼盘描述"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="openDate"
            label="开盘时间"
            align="center"
            width="150"
          ></el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageChange(row)"
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  style="width: 90px; margin: 0 0 10px 10px"
                  type="primary"
                  @click="messageDelete(row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 修改页面 -->
      <a-drawer
        title="修改"
        :width="1300"
        :visible="changevisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Change :ChangeData="changeData" />
      </a-drawer>
      <!-- 删除弹出框 -->
      <a-modal
        :visible="delOpen"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>确定要删除吗？</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import Change from "./change";
export default {
  components: {
    Change,
  },
  data() {
    return {
      addvisible: false,
      changevisible: false,
      delOpen: false,
      list: [], //留言列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示

      //查询的数据：
      searchData: {
        type: "", //类型
        phone: "", //手机号
        name: "", //楼盘名字
      },
      //类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "最新开盘",
        },
        {
          value: 2,
          label: "热门楼盘",
        },
      ],
      loading: false,
      addData: [],
      changeData: [],
      deleteId: "",
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //列表：
    getList() {
      this.postAxios("/houseInfo/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        houseInfo: {
          type: this.searchData.type, //类型
          phone: this.searchData.phone, //楼盘手机号
          floorName: this.searchData.name,
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 添加
    messageAdd(row) {
      this.$router.push('/houseInfoAdd')
    },
    // 修改
    messageChange(row) {
      this.changevisible = true;
      this.changeData = row;
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios(`/houseInfo/delete?id=${this.deleteId}`).then((res) => {
        if (res.success == true) {
          this.getList();
          this.$message.success(res.message);
          this.delOpen = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 删除
    messageDelete(row) {
      this.deleteId = row.id;
      this.delOpen = true;
    },
    onClose() {
      this.addvisible = false;
      this.changevisible = false;
      this.getList();
    },
    //查询列表：
    messageSearch() {
      this.currentPage = 1;
      this.loading = true;
      this.postAxios("/houseInfo/list", {
        page: {
          pageNum: this.currentPage,
          pageSize: 10,
        },
        houseInfo: {
          type: this.searchData.type, //类型
          phone: this.searchData.phone, //楼盘手机号
          floorName: this.searchData.name,
        },
      }).then((res) => {
        if (res.success == true) {
          this.list = res.content;
          this.totalCount = res.totalCount;
          this.loading = false;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //清空查询条件：
    topicClear() {
      this.searchData = {};
      this.getList();
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.getList(); //获取留言列表
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>